import { useMemo } from 'react';
import { useAppSelector, imageMaskingState } from 'src/store';

export const useIsOpenModalImagesList = () => {
  const { isOpenModalImagesList } = useAppSelector(imageMaskingState);

  return useMemo(
    () => ({
      isOpenModalImagesList,
    }),
    [isOpenModalImagesList],
  );
};
